module.exports = __webpack_public_path__ + "static/img/color.e2ad8712.jpg";